import { ReviewsAggregatorService } from '@weave/schema-gen-ts/dist/schemas/reviews/aggregator/v1/reviews_aggregator.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaReviewsAggregatorV1Service = bindHTTP(ReviewsAggregatorService);
export const serviceName = 'reviews-aggregator-v1' as const;
